import "../scss/index.scss";

document.addEventListener(
    "DOMContentLoaded",
    function () {
        toggleCart();
        toggleAccount();
        issuuEmbed();
        wooQtyChange();
        calculateSubtotal();
        customSelects();
        sortShopButton();
        shopDisplayButtons();
        stickOnScroll();
        toggleAccountMenu();
        toggleCheckoutFields();
        checkoutContinueButtons();
        mobileToggleMenu();
        autoSlideSlider();
    }
);

/**
 * Toggle the mini cart menu item
 */
function toggleCart() {
    const cart = document.querySelector(".wc-menu-cart__container");
    const cartToggle = document.querySelector(".wc-menu-cart__toggle-button");
    const cartClose = document.querySelector(".wc-menu-cart__close-button");
    const cartWrapper = document.querySelector(".wc-menu-cart__container");
    if (!cart || !cartToggle || !cartClose) return;

    cartToggle.addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelector(".wc-menu-account").classList.remove("show");
        cart.classList.toggle("show");
    });
    cartClose.addEventListener("click", function () {
        cart.classList.remove("show");
    });
}

/**
 * Toggle the account menu item
*/
function toggleAccount() {
    const accountToggle = document.querySelector(".wc-menu-account__toggle-button");
    const account = document.querySelector(".wc-menu-account");
    if (!accountToggle || !account) return;

    accountToggle.addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelector(".wc-menu-cart__container").classList.remove("show");
        account.classList.toggle("show");
    });
}

/**
 * Make issuu embed 100% width
 */
function issuuEmbed() {
    const issuuEmbed = document.querySelector(".issuuembed");
    if (!issuuEmbed) return;

    issuuEmbed.style.width = "100%";
    issuuEmbed.style.height = "763px";
}

/*
*  Adjust qty add to cart on button click
*/
function wooQtyChange() {
    const decreasebtn = document.querySelectorAll(".qty_less_btn");
    const increasebtn = document.querySelectorAll(".qty_more_btn");
    let wrapper;
    let qty;
    let minQty;

    if (decreasebtn.length > 1) {
        minQty = 0;
    } else {
        minQty = 1;
    }



    if (!decreasebtn && !increasebtn) return;

    // loop decrease btns
    for (let i = 0; i < decreasebtn.length; i++) {
        decreasebtn[i].addEventListener("click", function (e) {
            e.preventDefault();
            wrapper = decreasebtn[i].parentNode;

            qty = wrapper.querySelector("input.qty");
            if (qty.value > minQty) {
                qty.value--;
            }
            calculateSubtotal();
        });
    }

    // loop increase btns
    for (let i = 0; i < increasebtn.length; i++) {
        increasebtn[i].addEventListener("click", function (e) {
            e.preventDefault();
            wrapper = increasebtn[i].parentNode;
            qty = wrapper.querySelector("input.qty");
            qty.value++;
            calculateSubtotal();

        });
    }

}

/*
*  Calculate subtotal
*/
function calculateSubtotal() {
    const subTotal = document.querySelector("#group-subtotal");
    if (!subTotal) return;

    const qty = document.querySelectorAll("input.qty");
    if (!qty) return;

    let total = 0;

    for (let i = 0; i < qty.length; i++) {
        const wrapper = qty[i].parentNode;
        const tr = wrapper.parentNode.parentNode.parentNode;
        const price = tr.querySelector(".amount bdi").textContent;
        // remove all non numeric characters
        const priceClean = price.replace(/[^0-9.]/g, "");
        // convert price to int with 2 decimals
        const priceInt = parseFloat(priceClean);

        // multiple price with qty
        const priceTotal = priceInt * qty[i].value;
        // add to total
        total += priceTotal;
    }

    total = parseFloat(total).toFixed(2);
    subTotal.textContent = total;

}

function customSelects() {
    const selectedAll = document.querySelectorAll(".wrapper-dropdown");

    selectedAll.forEach((selected) => {
        const optionsContainer = selected.children[2];
        const optionsList = selected.querySelectorAll("div.wrapper-dropdown li");

        selected.addEventListener("click", () => {
            let arrow = selected.children[1];

            if (selected.classList.contains("active")) {
                handleDropdown(selected, arrow, false);
            } else {
                let currentActive = document.querySelector(".wrapper-dropdown.active");

                if (currentActive) {
                    let anotherArrow = currentActive.children[1];
                    handleDropdown(currentActive, anotherArrow, false);
                }

                handleDropdown(selected, arrow, true);
            }
        });

        // update the display of the dropdown
        for (let o of optionsList) {
            o.addEventListener("click", () => {
                selected.querySelector(".selected-display b").innerHTML = o.innerHTML;

                // get the id of selected option
                const selectedId = selected.getAttribute("id");
                // get the value of selected option
                const selectedValue = o.getAttribute("value");

                const url = new URL(window.location.href);

                // add the selected option to the url
                switch( selectedId ) {
                    case "sort-dropdown":
                        url.searchParams.set("product_orderby", selectedValue);
                        break;

                    case "show-dropdown":
                        url.searchParams.set("product_count", selectedValue);
                        break;
                }

                // reload the page with the new url
                window.location = url.href;

            });
        }
    });

    // check if anything else ofther than the dropdown is clicked
    window.addEventListener("click", function (e) {
        if (e.target.closest(".wrapper-dropdown") === null) {
            closeAllDropdowns();
        }
    });

    // close all the dropdowns
    function closeAllDropdowns() {
        const selectedAll = document.querySelectorAll(".wrapper-dropdown");
        selectedAll.forEach((selected) => {
            const optionsContainer = selected.children[2];
            let arrow = selected.children[1];

            handleDropdown(selected, arrow, false);
        });
    }

    // open all the dropdowns
    function handleDropdown(dropdown, arrow, open) {
        if (open) {
            arrow.classList.add("rotated");
            dropdown.classList.add("active");
        } else {
            arrow.classList.remove("rotated");
            dropdown.classList.remove("active");
        }
    }

}

function sortShopButton() {
    const button = document.querySelector("button#sort");
    if (!button) return;

    const url = new URL(window.location.href);
    // click the button
    button.addEventListener("click", function (e) {
        e.preventDefault();
        // check if class contains desc
        if (button.classList.contains("desc")) {
            // remove desc
            button.classList.remove("desc");
            // add asc
            button.classList.add("asc");
            url.searchParams.set("product_order", "asc");
        } else {
            // remove asc
            button.classList.remove("asc");
            // add desc
            button.classList.add("desc");
            url.searchParams.set("product_order", "desc");
        }

        window.location = url.href;
    });
}

function shopDisplayButtons() {
    const buttons = document.querySelectorAll(".list-button");
    if (!buttons) return;

    const url = new URL(window.location.href);

    // loop through buttons and listen for click
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener("click", function (e) {
            e.preventDefault();
            // remove active class from all buttons
            for (let j = 0; j < buttons.length; j++) {
                buttons[j].classList.remove("active");
            }
            // add active class to clicked button
            buttons[i].classList.add("active");

            // get the id of the clicked button
            const buttonId = buttons[i].getAttribute("id");
            url.searchParams.set("product_view", buttonId);
            window.location = url.href;
        });
    }
}

function stickOnScroll() {
    const items = document.querySelectorAll(".stickElement");
    if (!items) return;

    for (let i = 0; i < items.length; i++) {
        
        const itemHeight = items[i].offsetHeight;

        window.addEventListener("scroll", function () {
            if (window.pageYOffset > itemHeight) {
                items[i].classList.add("sticky");
            } else {
                items[i].classList.remove("sticky");
            }
        });

    }
}

function toggleAccountMenu() {
    const menuItems = document.querySelectorAll(".account-menu-item");
    if (!menuItems) return;

    for (let i = 0; i < menuItems.length; i++) {
        let link = menuItems[i].querySelector("a");
        if (!link) return;
        // click on link add active class to parent
        link.addEventListener("click", function (e) {
            e.preventDefault();
            // remove active class from all other items
            for (let j = 0; j < menuItems.length; j++) {
                menuItems[j].classList.remove("active");
            }
            menuItems[i].classList.toggle("active");

            // get the class of the clicked item
            const clickedClass = link.getAttribute("class");
            
            // get the element to show
            const element = document.querySelector(`#${clickedClass}-change`);
            if (!element) return;
            const allElements = document.querySelectorAll(".account-footer_content");
            // hide all other elements
            for (let k = 0; k < allElements.length; k++) {
                allElements[k].classList.remove("show");
            }
            element.classList.add("show");

        });
    };
}

function toggleCheckoutFields() {
    const checkoutNav = document.querySelector(".woocommerce-checkout-nav");
    if (!checkoutNav) return;

    const checkoutElements = document.querySelectorAll(".checkout-element");

    // get all the list items from the nav
    const navItems = checkoutNav.querySelectorAll("li");

    // get all anchors from the nav
    const navLinks = checkoutNav.querySelectorAll("a");
    
    // loop nav links and listen for click
    for(let i = 0; i < navLinks.length; i++) {
        navLinks[i].addEventListener("click", function(e) {
            e.preventDefault();
            // get the id of the clicked link
            const clickedId = navLinks[i].getAttribute("data-name");

            // remove active class from all nav items
            for(let j = 0; j < navItems.length; j++) {
                navItems[j].classList.remove("active");
            }

            // get the parent list item
            const parentListItem = navLinks[i].parentElement;
            // add active class to parent list item
            parentListItem.classList.add("active");


            // loop through all the checkout elements
            for(let j = 0; j < checkoutElements.length; j++) {
                // check if clickedId is in classlist and if is set class to show or remove show class
                if(checkoutElements[j].classList.contains(clickedId)) {
                    checkoutElements[j].classList.add("active");
                } else {
                    checkoutElements[j].classList.remove("active");
                }
            }
        });
    }
}

function checkoutContinueButtons() {
    const buttons = document.querySelectorAll(".woocommerce-checkout .btn.continue");
    if (!buttons) return;

    const shippingNav = document.querySelector("#toggle-shipping");
    const reviewNav = document.querySelector("#toggle-review");

    // loop through buttons and listen for click
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener("click", function (e) {
            e.preventDefault();

            // get the element
            const element = buttons[i].parentElement.parentElement;

            // check if element has class billing-element or shipping-element
            if(element.classList.contains("billing-element")) {
                if(shippingNav) {
                    shippingNav.click();
                }
            } else if(element.classList.contains("shipping-element")) {
                if(reviewNav) {
                    reviewNav.click();
                }
            }
        });
    }
}

function mobileToggleMenu() {
    const toggleMenu = document.querySelector(".mobile-menu");
    if (!toggleMenu) return;

    const navbar = document.querySelector(".primary-menu");
    toggleMenu.addEventListener("click", function (e) {
        e.preventDefault();
        navbar.classList.toggle("collapse");
        navbar.classList.toggle("active");
        navbar.parentElement.classList.toggle("active");
    });
}

function autoSlideSlider() {
    const timing = 10000;
    const slider = document.querySelector(".hero-slider");
    if(slider) {
        setInterval(function() {
            const radios = slider.querySelectorAll(".dot");
            let checked = slider.querySelector(".dot:checked");
            // get data key
            const dataKey = checked.getAttribute("data-key");
            // get next data key
            const nextKey = parseInt(dataKey) + 1;
            let next = slider.querySelector("#dot" + nextKey);
            if(next) {
                console.log(next);
                next.click();
            } else {
                radios[0].click();
            }
        }, timing);

    }
}